import { Router, Route, Switch } from "react-router-dom";

//Pages
import Quotes from 'pages/quotes/Quotes';
import Customer from 'pages/capacity/Customer';

//Route History
import history from './history';
import { AppLinks } from 'shared/shared.models';

//Styles
import './styles/app.scss';


const  App = () => {
  return (
    <div className="app">
      <Router history={history}>
        <main className="desktop">
          <Switch>
            <Route exact path={`/:mpan?`} component={ Customer } />
            <Route exact path={AppLinks.Quotes} component={ Quotes } />
          </Switch>
        </main>
      </Router>
      <div className="copyright">© NGP EMS LIMITED {new Date().getFullYear()}</div>
    </div>
  );
}

export default App;
